import React, { useState, useContext } from "react";

import MenuItem from "@material-ui/core/MenuItem";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import EncaminharModal from "./EncaminharModal";
import { Menu } from "@material-ui/core";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { EditingMessageContext } from "../../context/EditingMessage/EditingMessageContext";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  menu: {
    "& .MuiPaper-root": {
      borderRadius: 12,
      minWidth: 130,
      padding: "4px 0",
      boxShadow: "0 6px 24px rgba(0,0,0,0.12)",
    }
  },
  menuItem: {
    fontSize: "0.85rem",
    padding: "6px 14px",
    margin: "2px 6px",
    borderRadius: 6,
    transition: "all 0.15s ease",
    "&:hover": {
      backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.08)" : "#f0f2f5",
      transform: "translateX(2px)",
    }
  }
}));

const MessageOptionsMenu = ({ message, menuOpen, handleClose, anchorEl }) => {
  const classes = useStyles();
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const { setEditingMessage } = useContext(EditingMessageContext);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [encaminharAberto, setEncaminharAberto] = useState(false);

  // Nota interna, nota do programador e comunicado nunca saem para o WhatsApp.
  const podeEncaminhar =
    !message?.isDevNote &&
    !message?.isComunicado &&
    !String(message?.id || "").startsWith("system_") &&
    (String(message?.body || "").trim() || message?.mediaUrl);

  const handleDeleteMessage = async () => {
    try {
      await api.delete(`/messages/${message.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  const hanldeReplyMessage = () => {
    setReplyingMessage(message);
    handleClose();
  };

  const handleEditMessage = () => {
    setEditingMessage(message);
    handleClose();
  };

  const handleOpenConfirmationModal = (e) => {
    setConfirmationOpen(true);
    handleClose();
  };

  const podeSalvarFigurinha =
    !!message?.mediaUrl &&
    (message.mediaType === "sticker" ||
      (message.mediaType === "image" && /\.webp(\?.*)?$/i.test(message.mediaUrl)));

  const salvarFigurinha = async () => {
    handleClose();
    try {
      await api.post(`/stickers/from-message/${message.id}`);
      toast.success("Figurinha salva na sua coleção!");
    } catch (err) {
      toastError(err);
    }
  };

  const podeEditar = message.fromMe && message.mediaType === "chat" && message.devPayload === "sent_by_human";

  return (
    <>
      <ConfirmationModal
        title={i18n.t("messageOptionsMenu.confirmationModal.title")}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteMessage}
      >
        {i18n.t("messageOptionsMenu.confirmationModal.message")}
      </ConfirmationModal>
      <EncaminharModal
        open={encaminharAberto}
        onClose={() => setEncaminharAberto(false)}
        message={message}
      />
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={menuOpen}
        onClose={handleClose}
        className={classes.menu}
      >
        {message.fromMe && (
          <MenuItem className={classes.menuItem} onClick={handleOpenConfirmationModal}>
            {i18n.t("messageOptionsMenu.delete")}
          </MenuItem>
        )}
        
        {podeEditar && (
          <MenuItem className={classes.menuItem} onClick={handleEditMessage}>
            Editar
          </MenuItem>
        )}

        <MenuItem className={classes.menuItem} onClick={hanldeReplyMessage}>
          {i18n.t("messageOptionsMenu.reply")}
        </MenuItem>

        {podeEncaminhar && (
          <MenuItem
            className={classes.menuItem}
            onClick={() => {
              setEncaminharAberto(true);
              handleClose();
            }}
          >
            Encaminhar
          </MenuItem>
        )}

        {podeSalvarFigurinha && (
          <MenuItem className={classes.menuItem} onClick={salvarFigurinha}>
            Salvar figurinha
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default MessageOptionsMenu;
